import { useTranslation } from '../../../../../utils/useTranslation';
import { IconArrowDown } from '../../../../icon/IconArrowDown';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Column, DateColumn, Row } from '../../styles';
import { ROW_HEIGHT } from './constants';

export const ContentPromotionPostsDialogHeader: React.FC<{}> = () => {
    const t = useTranslation();

    return (
        <Row py={0} pr={1} height={ROW_HEIGHT}>
            <Column alignItems="center" />
            <Flex width={64} flexShrink={0}>
                <Typography variant="caption" color="secondary">
                    {t('Контент')}
                </Typography>
            </Flex>
            <Column alignSelf="unset" flexGrow={1} alignItems="flex-start">
                <Typography variant="caption" color="secondary">
                    {t('Описание')}
                </Typography>
            </Column>
            <DateColumn direction="row" justifySelf="end" justifyContent="flex-end">
                <Typography variant="caption" color="secondary">
                    {t('Дата')}
                </Typography>
                <IconArrowDown size={12} alignSelf="center" color="var(--color-primary)" />
            </DateColumn>
        </Row>
    );
};
